import { ROLES, TIERS } from '../common/utility/roleConstants';
import { createPermissionService } from '../common/utility/permissionService';

export const PLAN_TIERS = {
  FREE: 'free',
  PROFESSIONAL: 'professional',
  ELITE: 'elite',
};

const SUBSCRIPTION_STATUSES = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
  TRIAL: 'trial',
  PAST_DUE: 'past_due',
  CANCELLED: 'cancelled',
};

export const PLAN_TIER_BY_USER_TIER = {
  [TIERS.FREE]: PLAN_TIERS.FREE,
  [TIERS.PREMIUM]: PLAN_TIERS.PROFESSIONAL,
  [TIERS.ELITE]: PLAN_TIERS.ELITE,
};

export function getPrimaryRole(roles) {
  const list = Array.isArray(roles) ? roles : [];

  if (list.includes(ROLES.ADMIN)) {
    return ROLES.ADMIN;
  }
  if (list.includes(ROLES.PRO2)) {
    return ROLES.PRO2;
  }
  if (list.includes(ROLES.PRO1)) {
    return ROLES.PRO1;
  }
  if (list.includes(ROLES.PREMIUM)) {
    return ROLES.PREMIUM;
  }
  return ROLES.BASIC;
}

export function getPlanTier(auth) {
  const permissions = createPermissionService(auth);
  return PLAN_TIER_BY_USER_TIER[permissions.getCurrentTier()] || PLAN_TIERS.FREE;
}

function subscriptionStatusFromProfile(profile, planTier) {
  if (profile?.initiated_orders?.length > 0 || profile?.pending_subscriptions?.length > 0) {
    return SUBSCRIPTION_STATUSES.PAST_DUE;
  }
  if (profile?.halted_subscriptions?.length > 0 && !profile?.active_subscriptions?.length) {
    return SUBSCRIPTION_STATUSES.CANCELLED;
  }
  if (typeof profile?.demo_status === 'string' && profile.demo_status.startsWith('Started')) {
    return SUBSCRIPTION_STATUSES.TRIAL;
  }
  if (profile?.subscriber === false && planTier !== PLAN_TIERS.FREE) {
    return SUBSCRIPTION_STATUSES.EXPIRED;
  }
  return SUBSCRIPTION_STATUSES.ACTIVE;
}

export function getSubscriptionStatus(auth, planTier = getPlanTier(auth)) {
  if (auth?.subscription_status && Object.values(SUBSCRIPTION_STATUSES).includes(auth.subscription_status)) {
    return auth.subscription_status;
  }
  if (
    auth?.active_subscriptions ||
    auth?.pending_subscriptions ||
    auth?.initiated_orders ||
    auth?.halted_subscriptions ||
    auth?.demo_status
  ) {
    return subscriptionStatusFromProfile(auth, planTier);
  }
  if (auth?.subscriber === false && planTier !== PLAN_TIERS.FREE) {
    return SUBSCRIPTION_STATUSES.EXPIRED;
  }
  return SUBSCRIPTION_STATUSES.ACTIVE;
}

export function getSubscriptionPersonProperties(profile) {
  if (!profile) {
    return {};
  }
  const active = profile.active_subscriptions?.[0];
  return {
    ...(active?.subscription_started_on ? { subscription_started_at: active.subscription_started_on } : {}),
    ...(active?.expiry_date ? { subscription_renews_at: active.expiry_date } : {}),
  };
}

export function getEventUserProperties(auth) {
  const permissions = createPermissionService(auth);
  const user_tier = permissions.getCurrentTier();
  const plan_tier = PLAN_TIER_BY_USER_TIER[user_tier] || PLAN_TIERS.FREE;

  return {
    role: getPrimaryRole(auth?.role),
    user_tier,
    plan_tier,
    subscription_status: getSubscriptionStatus(auth, plan_tier),
  };
}
